export default "__VITE_ASSET__C0M5riQF__"